import { useState } from 'react';
import PropTypes from 'prop-types';
import InfiniteList from '@comp/InfiniteList/InfiniteList';
import Dialog from '@comp/Dialog/Dialog';
import TestSeriesCard from '@comp/TestSeriesCard/TestSeriesCard';
import { fetchSeeAllTypeFeed } from '@actions/specialClasses';
import { useDispatchToStore } from '@hooks/reduxHooks';
import { toggleEnrolledCourse } from '@actions/courses';

const TestSeriesFeedBlock = ({
  goalUID,
  testSeriesFeedBlock,
  goalkey,
  blockId,
  defaultBlockURL,
  seeAllType,
  blockType,
  label
}) => {
  const dispatch = useDispatchToStore();
  const [unEnrollModalOpen, setUnEnrollModalOpen] = useState(false);
  const [courseSelected, setcourseSelected] = useState(null);

  const message =
    'This course will be removed from your schedule and you will stop receiving updates related to this course';

  const acceptOnClick = () => {
    dispatch(toggleEnrolledCourse(courseSelected, false));
    setUnEnrollModalOpen(false);
  };

  const onCloseModal = () => {
    setUnEnrollModalOpen(false);
    setcourseSelected(null);
  };

  const renderEachClass = (testData, index) => (
    <TestSeriesCard
      key={testData.uid}
      test={testData}
      index={index}
      label={label}
    />
  );

  const loadMoreClasses = () => {
    return dispatch(
      fetchSeeAllTypeFeed(
        goalUID,
        blockType,
        defaultBlockURL,
        blockId,
        seeAllType,
        true
      )
    );
  };
  if (testSeriesFeedBlock[goalkey]?.results) {
    return (
      <>
        <Dialog
          onClose={onCloseModal}
          dialogState={unEnrollModalOpen}
          heading="Are you sure you want to unenroll?"
          message={message}
          acceptLabel="Unenroll"
          rejectLabel="Cancel"
          acceptOnClick={acceptOnClick}
          rejectOnClick={onCloseModal}
        />
        <InfiniteList
          loadMore={loadMoreClasses}
          _renderItem={renderEachClass}
          data={testSeriesFeedBlock[goalkey]}
          gridColumn="span 18"
        />
      </>
    );
  }
  return null;
};

export default TestSeriesFeedBlock;

TestSeriesFeedBlock.propTypes = {
  goalUID: PropTypes.string.isRequired,
  goalkey: PropTypes.string.isRequired,
  blockId: PropTypes.string.isRequired,
  defaultBlockURL: PropTypes.string.isRequired,
  seeAllType: PropTypes.string.isRequired,
  blockType: PropTypes.string.isRequired,
  testSeriesFeedBlock: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string.isRequired
};
